const SpanDefault = ({text}) => {
    return (
        <span className="inline-block rounded-[12px] h-[24px] lg:w-[68px] w-16 lg:text-base text-[15px] bg-[#BDBDBD] text-black">
            {text}
        </span>
    );
};

export default SpanDefault;